var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6447_12975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2303 15.68L22.2103 15.65L21.4403 14.36L21.4003 14.3C20.8903 13.45 20.5203 12.52 20.2903 11.56C20.2503 11.23 20.1903 10.84 20.1103 10.39C19.5403 10.57 18.9403 10.66 18.3103 10.66C15.0003 10.66 12.3103 7.96999 12.3103 4.65999C12.3103 2.97999 13.0003 1.46999 14.1103 0.37999C13.3303 0.12999 12.5003 -0.0100098 11.6403 -0.0100098C7.51033 -9.76585e-06 4.03033 3.10999 3.58033 7.21999L3.24033 10.24V10.31C3.07033 11.72 2.61033 13.07 1.89033 14.29L1.85033 14.35L1.08033 15.64L1.06033 15.67C0.730332 16.23 0.450333 16.69 0.270333 17.07C0.0903326 17.46 -0.0496674 17.87 0.0203326 18.31C0.100333 18.79 0.340333 19.22 0.710333 19.53C1.05033 19.82 1.48033 19.91 1.91033 19.95C2.33033 19.99 2.87033 19.99 3.52033 19.99H7.15033C7.15033 19.99 7.15033 20 7.15033 20.01C7.41033 21.13 7.98033 22.13 8.78033 22.85C9.59033 23.58 10.6103 23.98 11.6503 23.98C12.6903 23.98 13.7103 23.58 14.5203 22.85C15.3103 22.14 15.8903 21.13 16.1503 20.01C16.1503 20.01 16.1503 20 16.1503 19.99H19.7803C20.4303 19.99 20.9703 19.99 21.3903 19.95C21.8103 19.91 22.2403 19.81 22.5903 19.53C22.9603 19.22 23.2103 18.79 23.2803 18.31C23.3503 17.87 23.2103 17.45 23.0303 17.07C22.8503 16.69 22.5703 16.23 22.2403 15.67L22.2303 15.68Z",
    fill: "#028383"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3203 8.66998C20.5295 8.66998 22.3203 6.87912 22.3203 4.66998C22.3203 2.46084 20.5295 0.669983 18.3203 0.669983C16.1112 0.669983 14.3203 2.46084 14.3203 4.66998C14.3203 6.87912 16.1112 8.66998 18.3203 8.66998Z",
    fill: "#FF3434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6447_12975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationActiveIcon);
export default __webpack_public_path__ + "static/media/notificationActiveIcon.c8d2fe8e402bdb676927bce6823ad051.svg";
export { ForwardRef as ReactComponent };